import { render, staticRenderFns } from "./device.component.vue?vue&type=template&id=57455854&scoped=true"
import script from "./device.component.vue?vue&type=script&lang=ts"
export * from "./device.component.vue?vue&type=script&lang=ts"
import style0 from "./device.component.vue?vue&type=style&index=0&id=57455854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57455854",
  null
  
)

export default component.exports